import {useEffect} from "react";
import { useDispatch, useSelector } from "react-redux";
import { EnumGroupStatisticSourceOrders } from "../../../../../../server/routes/statistic/getSourceOrders/types";
import useMarketplacesFilter from "../../../../components/FilterMarketplacesProvider/useFilterMarketplaces";
import useTestMode from "../../../../components/TestModeProvider/useTestMode";
import getToken from "../../../../getters/getToken";
import useAlerts from "../../../../hooks/useAlerts";
import { getStatisticSourceOrders } from "../../../../requests";
import {
  actionDatesChange,
  actionLoadingFail,
  actionLoadingStart,
  actionLoadingSuccessfully
} from "../../../../store/statisticSourceOrders/actions";
import { useStatusGroup } from "../../StatusGroupProvider";
import moment from "moment";

export type Loader = (params?: {
  fromDate?: Date;
  toDate?: Date;
  group?: EnumGroupStatisticSourceOrders;
}) => Promise<void>;

const useLoading = (hideFakeOrders: boolean): Loader => {
  const { statusGroup } = useStatusGroup();
  const store = useSelector(
    ({
      statisticSourceOrders: {
        [statusGroup]: { fromDate, toDate, group },
      },
    }) => ({
      fromDate,
      toDate,
      group,
    })
  );
  const apiGetStatisticSourceOrders = getStatisticSourceOrders.bind(
    null,
    getToken(),
    statusGroup
  );
  const dispatch = useDispatch();
  const alert = useAlerts();
  const {
    isLoading: filteringMarketplacesloading,
    active: filteringMarketplaces,
  } = useMarketplacesFilter();
  const { testMode } = useTestMode();
  const loading: Loader = (args) => {
    dispatch(actionLoadingStart(statusGroup));
    if (testMode === null) {
      return Promise.resolve();
    }
    if (filteringMarketplacesloading) {
      return Promise.resolve();
    }
    return apiGetStatisticSourceOrders({
      fromDate: args?.fromDate ?? store.fromDate,
      toDate: args?.toDate ?? store.toDate,
      group: args?.group ?? store.group,
      marketplaceTypes:
        filteringMarketplaces.length > 0 ? filteringMarketplaces : undefined,
      hideFakeOrders,
    })
      .then(({ list }) => {
        dispatch(actionLoadingSuccessfully({ statusGroup, list }));
      })
      .catch(({ message }: Error) => {
        alert({ message, variant: "error" });
        dispatch(actionLoadingFail({ statusGroup, error: message }));
      });
  };
  useEffect(() => {
    if (testMode === true) {
      const toDate = moment(new Date(2022, 5, 3));
      const fromDate = moment(new Date(2022, 5, 1));
      dispatch(actionDatesChange({ statusGroup, fromDate, toDate }));
      loading({ fromDate, toDate });
    } else {
      loading();
    }
  }, [testMode]);
  return loading;
};
export default useLoading;
